(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hlp-urnenrechner"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hlp-urnenrechner')) {
  customElements.define('hlp-urnenrechner', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const form = this.querySelector('form');
      const animal = form.elements.animal;
      const subtype = form.elements.subtype;
      const weight = form.elements.weight;
      const result = this.querySelector('[data-result]');
      const cards = Array.from(this.querySelectorAll('[data-capacity]'));
      const messages = this.querySelector('[data-messages]').content;
      const message = key => messages.querySelector(`[data-key="${key}"]`).textContent;
      const formatter = new Intl.NumberFormat(this.dataset.locale || 'de', {minimumFractionDigits:1, maximumFractionDigits:1});
      const reset = () => { result.hidden = true; weight.setCustomValidity(''); };
      form.addEventListener('input', reset);
      form.addEventListener('change', () => {
        const small = animal.value === 'small';
        this.querySelector('[data-subtype]').hidden = !small;
        subtype.disabled = !small;
        subtype.required = small;
        reset();
      });
      form.addEventListener('submit', event => {
        event.preventDefault();
        const raw = weight.value.trim();
        const kg = Number(raw.replace(',', '.'));
        if (!/^\d+(?:[.,]\d+)?$/.test(raw) || !Number.isFinite(kg) || kg <= 0) {
          weight.setCustomValidity(message('error'));
          weight.reportValidity();
          return;
        }
        weight.setCustomValidity('');
        if (!form.reportValidity()) return;
        const bird = animal.value === 'small' && subtype.value === 'bird';
        const rodent = animal.value === 'small' && subtype.value === 'rodent';
        const smallDogOrCat = (animal.value === 'dog' || animal.value === 'cat') && kg <= 3.5;
        const tiers = [[5,500],[10,700],[15,1000],[25,1500],[35,2000],[45,2500],[60,3000]];
        const capacity = kg > 60 ? null : bird ? 100 : rodent && kg <= 3 ? 300 : smallDogOrCat ? 400 : tiers.find(([limit]) => kg <= limit)?.[1];
        cards.forEach(card => { card.hidden = true; });
        const hasEstimate = capacity != null;
        this.querySelector('[data-result-title]').textContent = hasEstimate ? message('result') : message('above');
        this.querySelector('[data-result-value]').textContent = hasEstimate ? `${message('approx')} ${formatter.format(capacity / 1000)} ${message('unit')}` : '';
        this.querySelector('[data-texture-note]').textContent = hasEstimate ? message(`${form.elements.texture.value}_note`) : '';
        this.querySelector('[data-bird-note]').hidden = !bird || !hasEstimate;
        const best = new Map();
        if (hasEstimate) cards.forEach(card => {
          const size = Number(card.dataset.capacity);
          const family = card.dataset.family;
          if (size >= capacity && (!best.has(family) || size < Number(best.get(family).dataset.capacity))) best.set(family, card);
        });
        best.forEach(card => { card.hidden = false; });
        this.querySelector('[data-products-title]').hidden = best.size === 0;
        this.querySelector('[data-no-products]').hidden = !hasEstimate || best.size > 0;
        result.hidden = false;
        result.focus({preventScroll:true});
        result.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',block:'start'});
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
